import React, { useEffect, useState } from 'react'
import { Card, Table } from 'reactstrap'
import MyPagination from '../pagination'
import { useLoader } from '../../_helper/LoaderContext';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SearchIcon } from 'lucide-react';
import { collectionList } from './service/collection-service';
import { Tooltip } from 'react-tooltip';
import { useLab } from '../../_helper/PharmacyProvider';
import { useCurrency } from '../../_helper/currencyContext';
import DatePicker from "react-datepicker";
import { FormLabel } from 'react-bootstrap';

export default function CollectionHome() {
    const { t } = useTranslation()
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const [collection, setCollection] = useState([]);
    const { currentLab } = useLab();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const { getCurrencySymbol } = useCurrency()

    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage, search, startDate, endDate])

    const formatApiDate = (date) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const getList = async () => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", search);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            if (currentLab?.isAdmin !== true) {
                form_data.append("cashierId", currentLab?._id);
            }
            if (startDate) {
                form_data.append("startDate", formatApiDate(startDate));
            }
            if (endDate) {
                form_data.append("endDate", formatApiDate(endDate));
            }
            const res = await collectionList(form_data);
            if (res.data.success == true) {
                setCollection(res.data.data.list)
                setTotalEntries(res.data.data.total || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const formatDate = (dateString) => {
        if (!dateString) return "---";

        const date = new Date(dateString);

        return date.toLocaleString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };

    const normalizeDate = (date) => {
        if (!date) return null;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    return (
        <>
            <Card>
                <div className="px-3 mt-4">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-group mb-3 ">
                                <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                                <input type="text" className="form-control icon_form" placeholder="Search By Name" aria-label="Username" aria-describedby="basic-addon1" style={{ borderLeft: 'none' }}
                                    value={search} onChange={(e) => setSearch(e.target.value)} />
                            </div>

                        </div>
                        <div className="col-md-3">
                            <DatePicker
                                className="form-control"
                                selected={startDate}
                                onChange={(date) => {
                                    const normalized = normalizeDate(date);
                                    setStartDate(normalized);
                                    setEndDate(null);
                                }}
                                placeholderText="Start Date"
                                dateFormat="dd MMM yyyy"
                                isClearable
                            />

                        </div>

                        <div className="col-md-3">
                            <DatePicker
                                className="form-control"
                                selected={endDate}
                                onChange={(date) => setEndDate(normalizeDate(date))}
                                minDate={startDate}          // now works perfectly
                                dateFormat="dd MMM yyyy"
                                disabled={!startDate}
                                placeholderText="End Date"
                                isClearable
                            />

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black"
                                style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                <Table className="mb-0 table-center table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th className="bg-primary text-white text-left" style={{ width: '14%' }}><b>Name</b></th>
                                            <th className="bg-primary text-white text-left" style={{ width: '10%' }}><b>Login Time</b></th>
                                            <th className="bg-primary text-white" style={{ width: '9%' }}><b>Logout Time</b></th>
                                            <th className="bg-primary text-white" style={{ width: '9%' }}><b>Opening Amount</b></th>
                                            <th className="bg-primary text-white" style={{ width: '16%' }}><b>Earning Amount</b></th>
                                            {/* <th className="bg-primary text-white" style={{ width: '10%' }}><b>Balance Amount</b></th> */}
                                            {/* <th className="bg-primary text-white" style={{ width: '10%' }}><b>Status</b></th> */}
                                            {/* <th className="bg-primary text-white text-center" style={{ width: '11%' }}><b>Action</b></th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {collection.map((item, index) => (
                                            <tr key={item._id} className={index % 2 === 0 ? '' : ''}>

                                                <td className="tw-px-3 ps-2 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    <div
                                                        className="tw-font-medium tw-text-gray-900 tw-ps-3"
                                                    >
                                                    </div>
                                                    {item?.cashierName}
                                                </td>
                                                <td>
                                                    {formatDate(item?.shiftStartTime) || "---"}
                                                </td>
                                                <td>
                                                    {formatDate(item?.shiftEndTime) || "---"}
                                                </td>
                                                <td className='tw-font-bold'>
                                                    {getCurrencySymbol(currentLab.baseCurrency)}{item?.openingAmount[currentLab.baseCurrency]?.toFixed(2) || "0.00"}
                                                </td>
                                                <td className='tw-font-bold'>
                                                    {getCurrencySymbol(currentLab.baseCurrency)}{item?.closingAmount[currentLab.baseCurrency]?.toFixed(2) || "0.00"}
                                                </td>
                                                {/* <td className="tw-px-4 tw-py-4 text-center">
                                                    <div className="">
                                                        <Tooltip id="view" place="top" content="view" />
                                                        <button className='success-action-button me-1' data-tooltip-id="view">
                                                            <i className="fa fa-eye tw-text-red-600" style={{ fontSize: "18px" }}></i>
                                                        </button>
                                                    </div>
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="d-md-flex align-items-center text-center justify-content-between mt-3 mb-3">
                                <div className="show-entries">
                                    <FormLabel>Show&nbsp;</FormLabel>
                                    <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                                        onChange={handlePageSizeChange} className="form-control">
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={30}>30</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>&nbsp;
                                    <FormLabel>entries</FormLabel>
                                </div>
                                <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                            </div>
                            {/* <div className="mt-3 mb-3">
                                <MyPagination totalPages={totalPages}
                                    currentPage={currentPage}
                                    onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                            </div> */}
                        </div>
                    </div>
                </div>
            </Card>
        </>
    )
}
